import React from 'react'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from '../../util/reactIntl';
import { types as sdkTypes } from '../../util/sdkLoader';
import { TopbarContainer } from '../../containers';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  EarningsSection
} from '../../components';

import { loadData, handlePayout, loadNonCriticalData, loadTranferPage, savePayoutDetailsRequest, savePayoutDetailsSuccess, savePayoutDetailsError, setPayoutDetailsSaved, updateTransfersArray } from './BalancePage.duck'
import {
  stripeAccountClearError,
  createStripeAccount,
  updateStripeAccount,
  getStripeConnectAccountLink,
  saveClientClabeNumber
} from '../../ducks/stripeConnectAccount.duck';

import css from './BalancePage.css'

import { withRouter } from 'react-router-dom';
import { withViewport } from '../../util/contextHelpers';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';

const { UUID } = sdkTypes;

const BalancePageComponent = (props) => {

  const hasLoadedData = React.useRef(false);
  const {
    currentUser,
    onManageDisableScrolling,
    stripeAccountDataExternalAccount,
    onHandlePayout,
    initiatePayoutInProgess,
    initiatePayoutError,
    userCounter,
    totalPending,
    transfers,
    totalPages,
    paginationInfo,
    onLoadNonCriticalData,
    onLoadTranferPage,
    intl,
    // Stripe account props
    onPayoutDetailsFormChange,
    onPayoutDetailsSubmit,
    onGetStripeConnectAccountLink,
    onSaveClientClabeNumber,
    getAccountLinkInProgress,
    stripeAccount,
    stripeAccountFetched,
    stripeAccountLinkError,
    stripeAccountError,
    payoutDetailsSaveInProgress,
    payoutDetailsSaved
  } = props;

  React.useEffect(() => {
    if (currentUser && !hasLoadedData.current) {
      // Always try to fetch Stripe account data whether it exists yet or not
      onLoadNonCriticalData({
        userReferredCode: currentUser.attributes.profile.privateData.referralCode, 
        userId: currentUser.id.uuid, 
        stripeAccountId: currentUser?.stripeAccount?.attributes?.stripeAccountId
      });
      
      // We also need to make sure we have the stripeAccount data
      if (currentUser.stripeAccount && currentUser.stripeAccount.id) {
        // If the user has a Stripe account ID but we don't have the account data yet,
        // we should ensure it's fetched by the time the modal opens
        if (!stripeAccount || !stripeAccountFetched) {
          console.log('Stripe account exists but not fully fetched - getting data');
          // This would typically be handled by the stripeConnectAccount duck
          // The store already has reducers subscribed via mapStateToProps
        }
      }
      
      hasLoadedData.current = true;
    }
  }, [currentUser, stripeAccount, stripeAccountFetched]);
  

  if(!currentUser)   return (
    <Page title={"schemaTitle"} scrollingDisabled={true} >
      <LayoutSideNavigation className={css.layoutBalance} >
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="BalancePage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav/>
        <LayoutWrapperMain>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  )






  const userStripeAccountMaybe = currentUser?.stripeAccount?.attributes?.stripeAccountId;

  const userEarnings = currentUser.attributes.profile.privateData.userEarnings ? currentUser.attributes.profile.privateData.userEarnings: 0;

  const userCredits = currentUser.attributes.profile.privateData.userCredits ? currentUser.attributes.profile.privateData.userCredits : 0;

  const pendingCredits = totalPending ? totalPending : 0;
  

  const onHandlePayoutRequest = async (additionalParams = {}) => {
    const userId = currentUser.id.uuid;
  
    try {
      // For retry operations, we use a special flag to tell the server 
      // to use the actual Connect account balance for the email
      let emailAmount = userEarnings;
      
      // If it's a retry operation, set the special flag value
      if (additionalParams.isRetry) {
        emailAmount = -1; // Special flag to indicate "use actual Connect balance amount"
      }
      
      const result = await onHandlePayout({
        userId,
        userStripeAccountMaybe,
        emailReceiver: currentUser.attributes.email,
        emailData: {
          userEarnings: emailAmount, // Use the proper amount for email
          last4: stripeAccountDataExternalAccount?.last4,
          name: `${currentUser.attributes.profile.firstName} ${currentUser.attributes.profile.lastName}`,
        },
        ...additionalParams  // Include any additional parameters like isRetry and preserveStripeAccount
      });
      return { success: true, result };
    } catch (error) {
      throw error;
    }
  };
  


  const onLoadNewPage = (currentPage, newPage) => {
    // Only load transfers if a Stripe account ID is available
    if (userStripeAccountMaybe) {
      onLoadTranferPage({
        stripeAccountId: userStripeAccountMaybe, 
        currentPage, 
        action: 'specificPage', 
        targetPage: newPage, 
        paginationInfo
      });
    } else {
      console.warn('Cannot load transfers: No Stripe account ID available');
    }
  };

  return (
      <Page title={"Mi balance"} scrollingDisabled={false} >
        <LayoutSideNavigation >
          <LayoutWrapperTopbar>
            <TopbarContainer currentPage="BalancePage" />
          </LayoutWrapperTopbar>
          <LayoutWrapperMain className={css.layoutBalance}>
            <EarningsSection
              userEarnings={userEarnings}
              userCredits={userCredits}
              pendingCredits={pendingCredits}
              onManageDisableScrolling={onManageDisableScrolling}
              userCounter={userCounter}
              userStripeAccountMaybe={userStripeAccountMaybe}
              stripeAccountDataExternalAccount={stripeAccountDataExternalAccount}
              onHandlePayoutRequest={onHandlePayoutRequest}
              initiatePayoutInProgess={initiatePayoutInProgess}
              initiatePayoutError={initiatePayoutError}
              depositHistoryData={transfers}
              totalPages={totalPages}
              paginationInfo={paginationInfo}
              onLoadNewPage={onLoadNewPage}
              currentUser={currentUser}
              onPayoutDetailsFormChange={onPayoutDetailsFormChange}
              onPayoutDetailsSubmit={onPayoutDetailsSubmit}
              onGetStripeConnectAccountLink={onGetStripeConnectAccountLink}
              getAccountLinkInProgress={getAccountLinkInProgress}
              stripeAccount={stripeAccount}
              stripeAccountFetched={stripeAccountFetched}
              stripeAccountLinkError={stripeAccountLinkError}
              stripeAccountError={stripeAccountError}
              payoutDetailsSaveInProgress={payoutDetailsSaveInProgress}
              payoutDetailsSaved={payoutDetailsSaved}
              onSaveClientClabeNumber={onSaveClientClabeNumber}
              intl={intl}
              onLoadNonCriticalData={onLoadNonCriticalData}
            />
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSideNavigation>
      </Page>
    )
}


const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onHandlePayout: (data) =>
    dispatch(handlePayout(data)),
  onLoadNonCriticalData: (data) => 
    dispatch(loadNonCriticalData(data)),
  onLoadTranferPage: (data) => 
    dispatch(loadTranferPage(data)),
  updateTransfersArray: (data) =>
    dispatch(updateTransfersArray(data)),
  onPayoutDetailsFormChange: (data) =>
    dispatch(stripeAccountClearError(data)),
  onPayoutDetailsSubmit: (data, isUpdate) => {
    // Use updateStripeAccount if isUpdate is true (user has existing Stripe account)
    // Otherwise use createStripeAccount
    dispatch(savePayoutDetailsRequest());
    const action = isUpdate ? updateStripeAccount : createStripeAccount;
    return dispatch(action(data, { expand: true }))
      .then((response) => {
        dispatch(savePayoutDetailsSuccess());
        // Reset the "saved" state after a short delay
        setTimeout(() => {
          dispatch(setPayoutDetailsSaved(false));
        }, 2000);
        return response;
      })
      .catch((error) => {
        dispatch(savePayoutDetailsError(error));
        throw error;
      });
  },
  onGetStripeConnectAccountLink: (data) =>
    dispatch(getStripeConnectAccountLink(data)),
  onSaveClientClabeNumber: (data) =>
    dispatch(saveClientClabeNumber(data)),
  dispatch
});

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    userId,
    stripeAccountDataExternalAccount,
    initiatePayoutInProgess,
    initiatePayoutError,
    userCounter,
    totalPending,
    transfers,
    totalPages,
    paginationInfo,
    payoutDetailsSaveInProgress,
    payoutDetailsSaved
  } = state.BalancePage;
  
  const {
    getAccountLinkInProgress,
    getAccountLinkError: stripeAccountLinkError,
    createStripeAccountError: stripeAccountError,
    stripeAccount,
    stripeAccountFetched,
  } = state.stripeConnectAccount;
  
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    stripeAccountDataExternalAccount,
    initiatePayoutInProgess,
    initiatePayoutError,
    userCounter,
    totalPending,
    transfers,
    totalPages,
    paginationInfo,
    // Stripe account props
    getAccountLinkInProgress,
    stripeAccountLinkError,
    payoutDetailsSaveInProgress,
    payoutDetailsSaved,
    stripeAccountError,
    stripeAccount,
    stripeAccountFetched,
  };
};


const BalancePage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withViewport,
  injectIntl
)(BalancePageComponent);

BalancePage.loadData = (params, queryParams) => {
  return loadData();
};

export default BalancePage